<template>
    <div class="main atribuicao-salas">

        <c-panel>
            <el-form label-position="top" @submit.native.prevent="buscar()">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="4">
                        <el-form-item label="Ano">
                            <el-select v-model="filtro.periodo_letivo_id" placeholder="Ano" style="width: 100%" @change="limparResultado()">
                                <el-option v-for="item in $store.state.periodos" :key="item.id" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="precisaEscolherInstituicao" :xs="24" :sm="16" :md="10">
                        <el-form-item label="Unidade">
                            <el-select v-model="filtro.instituicao_id" filterable placeholder="Selecione a unidade" style="width: 100%" @change="limparResultado()">
                                <el-option v-for="item in $store.state.instituicoes" :key="item.id" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="precisaEscolherInstituicao ? 10 : 20">
                        <el-form-item label="Tipo de ensino">
                            <el-select v-model="filtro.tipo_ensino" placeholder="Selecione o tipo de ensino" style="width: 100%" @change="buscar()">
                                <el-option v-for="(nome, chave) in tipos" :key="chave" :label="nome" :value="chave"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" class="u-text-right">
                        <el-button type="primary" native-type="submit" :disabled="!filtrosCompletos" :loading="carregando">Buscar</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>

        <c-panel v-if="buscou" class="u-mt-20">
            <el-alert v-if="!podeEditar" type="info" :closable="false" show-icon class="u-mb-20" title="Somente consulta." />

            <el-input v-if="turmas.length > 6" v-model="busca" placeholder="Filtrar turma" suffix-icon="el-icon-search" clearable class="u-mb-20" style="max-width: 320px;" />

            <div v-if="!turmas.length" class="u-text-center u-mt-20 u-mb-20">
                <i>Nenhuma turma deste tipo de ensino na unidade.</i>
            </div>

            <div v-for="turma in turmasFiltradas" :key="turma.id" class="as-turma">
                <div class="as-turma-titulo">
                    {{ turma.nome }}
                    <span class="as-turma-curso" v-if="turma.curso">{{ turma.curso }}</span>
                    <span class="as-turma-resumo">{{ atribuidas(turma) }}/{{ turma.linhas.length }} atribuídas</span>
                </div>
                <div v-if="!turma.linhas.length" class="as-vazio">Turma sem disciplinas cadastradas.</div>
                <div v-for="linha in turma.linhas" :key="linha.area_conhecimento_id" class="as-linha">
                    <div class="as-disciplina">{{ linha.nome }}</div>
                    <div class="as-docente">
                        <el-select :value="linha.servidor_id" filterable clearable placeholder="Nenhum" style="width: 100%"
                            :disabled="!podeEditar || !!salvando[chave(turma, linha)]"
                            :class="{ 'as-sem-professor': !linha.servidor_id }"
                            @visible-change="(aberto) => aoAbrir(turma, linha, aberto)"
                            @change="(v) => atribuir(turma, linha, v)">
                            <!-- Opções só no select aberto: são todos os servidores da rede -->
                            <template v-if="aberto === chave(turma, linha)">
                                <el-option-group v-for="grupo in opcoes(linha)" :key="grupo.label" :label="grupo.label">
                                    <el-option v-for="d in grupo.itens" :key="d.servidor_id" :value="d.servidor_id" :label="d.nome"></el-option>
                                </el-option-group>
                            </template>
                            <el-option v-else-if="linha.servidor_id" :value="linha.servidor_id" :label="nomeServidor(linha.servidor_id)"></el-option>
                        </el-select>
                        <div v-if="linha.outros_servidores.length" class="as-aviso">
                            Também vinculado: {{ nomesServidores(linha.outros_servidores) }}. Ao escolher um professor, os demais são removidos.
                        </div>
                    </div>
                </div>
            </div>
        </c-panel>

    </div>
</template>

<script>
// Atribuição de salas: vínculo professor × turma × disciplina por unidade e tipo de ensino, como no
// sistema legado. Grava ao escolher o professor (api/enturmacao-professor/atribuir), fazendo o fluxo do
// cadastro do servidor de uma vez: cria a lotação como docente na unidade (se não houver), inclui a
// disciplina nas aptidões e faz a enturmação. O fluxo pelo cadastro do servidor continua valendo.
const TIPOS = {
    infantil: 'Educação Infantil',
    fundamental_1: 'Ensino Fundamental I',
    fundamental_2: 'Ensino Fundamental II',
    eja: 'EJA',
    aee: 'AEE',
    complementar: 'Atividade Complementar'
}

export default {
    data () {
        return {
            filtro: {
                periodo_letivo_id: this.$store.state.config.periodo ? this.$store.state.config.periodo.id : '',
                instituicao_id: '',
                tipo_ensino: ''
            },
            tipos: TIPOS,
            turmas: [],
            docentes: [],
            podeEditar: false,
            buscou: false,
            carregando: false,
            salvando: {},
            aberto: null,
            busca: ''
        }
    },
    computed: {
        precisaEscolherInstituicao () {
            return !this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id
        },
        instituicaoId () {
            return this.precisaEscolherInstituicao ? this.filtro.instituicao_id : this.$store.state.config.instituicao.id
        },
        filtrosCompletos () {
            return !!(this.filtro.periodo_letivo_id && this.instituicaoId && this.filtro.tipo_ensino)
        },
        turmasFiltradas () {
            const b = (this.busca || '').trim().toUpperCase()
            return b ? this.turmas.filter(t => t.nome.includes(b)) : this.turmas
        },
        porId () {
            const m = {}
            this.docentes.forEach(d => { m[d.servidor_id] = d })
            return m
        }
    },
    methods: {
        chave (turma, linha) {
            return `${turma.id}-${linha.area_conhecimento_id}`
        },
        limparResultado () {
            this.buscou = false
            this.turmas = []
            if (this.filtrosCompletos) this.buscar()
        },
        async buscar () {
            if (!this.filtrosCompletos) return
            this.carregando = true
            try {
                const payload = { ...this.filtro, instituicao_id: this.instituicaoId }
                const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/enturmacao-professor/getAtribuicao`, payload, this.$store.getters.getHeaderAuth)
                if (res.data.erro) {
                    window.eventBus.$emit('alert', { msg: res.data.erro, type: 'warning' })
                    return
                }
                this.turmas = res.data.turmas
                this.docentes = res.data.docentes
                this.podeEditar = !!res.data.pode_editar
                this.buscou = true
            } catch (e) {
                this.$store.commit('throwException', e)
            } finally {
                this.carregando = false
            }
        },
        aoAbrir (turma, linha, aberto) {
            if (aberto) this.aberto = this.chave(turma, linha)
        },
        // Aptos à disciplina (lotados na unidade) → lotados na unidade → demais servidores (lotação criada ao salvar).
        opcoes (linha) {
            const aptos = []
            const lotados = []
            const demais = []
            this.docentes.forEach(d => {
                if (d.lotado && d.aptas.includes(linha.area_conhecimento_id)) aptos.push(d)
                else if (d.lotado) lotados.push(d)
                else demais.push(d)
            })
            return [
                { label: 'Aptos à disciplina', itens: aptos },
                { label: 'Lotados na unidade', itens: lotados },
                { label: 'Demais servidores (a lotação na unidade é criada ao salvar)', itens: demais }
            ].filter(g => g.itens.length)
        },
        nomeServidor (id) {
            return this.porId[id] ? this.porId[id].nome : `#${id}`
        },
        atribuidas (turma) {
            return turma.linhas.filter(l => l.servidor_id).length
        },
        nomesServidores (ids) {
            return ids.map(id => this.nomeServidor(id)).join(', ')
        },
        async atribuir (turma, linha, servidorId) {
            const k = this.chave(turma, linha)
            const anterior = linha.servidor_id
            linha.servidor_id = servidorId || null
            this.$set(this.salvando, k, true)
            try {
                const payload = { turma_id: turma.id, area_conhecimento_id: linha.area_conhecimento_id, servidor_id: servidorId || null }
                const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/enturmacao-professor/atribuir`, payload, this.$store.getters.getHeaderAuth)
                if (res.data.erro) {
                    linha.servidor_id = anterior
                    window.eventBus.$emit('alert', { msg: res.data.erro, type: 'warning' })
                    return
                }
                linha.outros_servidores = []
                // Reflete a lotação e a aptidão criadas, para a ordem dos grupos nos próximos selects.
                const d = servidorId ? this.porId[servidorId] : null
                if (d) {
                    d.lotado = true
                    if (!d.aptas.includes(linha.area_conhecimento_id)) d.aptas.push(linha.area_conhecimento_id)
                }
                this.$message({ message: `${turma.nome} · ${linha.nome}: ${res.data.mensagem}`, type: 'success', duration: 2500 })
                if (res.data.sem_cpf) {
                    window.eventBus.$emit('alert', { msg: 'Servidor sem CPF cadastrado: a lotação foi criada, mas o login do professor não. Complete o CPF no cadastro do servidor.', type: 'warning' })
                }
            } catch (e) {
                linha.servidor_id = anterior
                this.$store.commit('throwException', e)
            } finally {
                this.$set(this.salvando, k, false)
            }
        }
    }
}
</script>

<style>
    .atribuicao-salas .as-turma {
        border: 1px solid #ebeef5;
        border-radius: 4px;
        margin-bottom: 16px;
    }
    .atribuicao-salas .as-turma-titulo {
        background: #1c69b3;
        color: #fff;
        font-weight: 600;
        padding: 8px 12px;
        border-radius: 4px 4px 0 0;
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
        gap: 10px;
    }
    .atribuicao-salas .as-turma-curso {
        font-weight: 400;
        font-size: 12px;
        opacity: .85;
    }
    .atribuicao-salas .as-turma-resumo {
        margin-left: auto;
        font-weight: 400;
        font-size: 12px;
    }
    .atribuicao-salas .as-linha {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 6px 12px;
        border-top: 1px solid #ebeef5;
    }
    .atribuicao-salas .as-linha:nth-child(odd) {
        background: #fafafa;
    }
    .atribuicao-salas .as-disciplina {
        flex: 0 0 260px;
        font-size: 13px;
        padding-right: 10px;
    }
    .atribuicao-salas .as-docente {
        flex: 1 1 300px;
        max-width: 520px;
    }
    .atribuicao-salas .as-sem-professor .el-input__inner {
        border-color: #e6a23c;
    }
    .atribuicao-salas .as-aviso {
        color: #e6a23c;
        font-size: 12px;
        margin-top: 2px;
    }
    .atribuicao-salas .as-vazio {
        padding: 12px;
        color: #909399;
        font-size: 13px;
    }
</style>
